'use strict';

window.console || (window.console = {
	log: function log() {}
});
var FUNCTIONS = window.FUNCTIONS || null;
var cssua = window.cssua || null;

(function ($) {
	var htmlHasClass = function htmlHasClass(_class) {
		return $('html').hasClass(_class);
	};
	var siteName = '';
	var a = 'is-active';
	var v = 'is-visible';
	var f = 'is-fixed';
	var slideSpeed = '400';

	FUNCTIONS = {
		va: {
			pathname: location.pathname,
			isMobile: htmlHasClass('ua-mobile'),
			device: {
				desktop: 1024,
				sp: 768
			},
			window: {
				width: $(window).width(),
				height: $(window).height()
			}
		},
		localDecision: function localDecision() {
			var regExp = new RegExp('(test\\.' + siteName + '\\.connecty\\.co\\.jp|copre\\.jp|localhost|192\\.168\\.)', 'g');
			return regExp.test(location.hostname);
		},
		localLoading: function localLoading() {
			var _this = this;
			// ローカル環境ならincludeをAjaxで読み込む
			var key = 'inc_';
			var ajaxArray = [];
			var ajaxArrayList = [];
			var i, j;
			var includeClass = document.querySelectorAll('[class*="' + key + '"]');
			var includeClassLen = includeClass.length;

			for (i = 0; i < includeClassLen; i++) {
				var path = includeClass[i].innerHTML.split(' ')[1];
				ajaxArray.push(path);
			}
			var ajaxLen = ajaxArray.length;

			if (ajaxLen > 0) {
				for (i = 0; i < ajaxLen; i++) {
					ajaxArrayList[i] = $.ajax({
						type: 'GET',
						url: ajaxArray[i] + '.html',
						dataType: 'html',
						timeout: 5000
					});
				}
				$.when.apply($, ajaxArrayList).done(function () {
					for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
						args[_key] = arguments[_key];
					}

					var regExp = new RegExp(key);

					for (i = 0; i < args.length; i++) {
						var result = args[i];
						var position = $(result[0]).filter(':first').attr('class').split(' ');

						for (j = 0; j < position.length; j++) {
							if (position[j].match(regExp)) {
								position = position[j];
								break;
							}
						}
						$('.' + position).html(result[0]).children().unwrap();

						console.log('Succeeded to read the include file!:', position);
					}
					_this.loadDelayScript();
				});
			} else {
				_this.loadDelayScript();
			}
		},
		catchAjaxError: function catchAjaxError(_errorThrown) {
			if (window.ga) {
				window.ga('send', 'event', 'ajaxError', location.href, _errorThrown, 0, true);
			}
		},
		getQuery: function getQuery() {
			var vars = [];
			var hash = null;
			var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
			for (var i = 0; i < hashes.length; i++) {
				hash = hashes[i].split('=');
				vars.push(hash[0]);
				vars[hash[0]] = hash[1];
			}
			return vars;
		},
		headerScroll: function headerScroll() {
			var $header = $('.header');
			var timer = void 0,
			    flag = void 0;
			var checkheaderScroll = function checkheaderScroll() {
				var thisScroll = $(window).scrollTop();
				if (timer) clearTimeout(timer);
				if (thisScroll === 0 && flag) {
					$header.removeClass('is-move');
					flag = false;
				} else if (thisScroll > 0 && !flag) {
					$header.addClass('is-move');
					flag = true;
				}
			};
			checkheaderScroll();
			$(window).scroll(function (e) {
				checkheaderScroll();
			});
		},

		// SP版のヘッダーのハンバーガーメニュー
		spMenu: function spMenu() {
			var $menu = $('.js-menuToggle');
			var $headerNav = $('.header-nav');
			var $headerNavInner = $('.header-nav-inner');
			var $headerNavSpMail = $('.header-nav_sp-mail');
			var scrollTopNow = 0;

			$menu.on('click', function () {
				if ($headerNavInner.hasClass(v)) {
					//メニューを閉じる
					$menu.removeClass(a);
					$headerNav.removeClass(a);
					$headerNavInner.removeClass(v);
					$headerNavSpMail.addClass(v);
					$('.container').css({
						position: 'static'
					});
					$('body').removeClass(f);

					$(window).scrollTop(scrollTopNow);
				} else {
					//メニューを開く
					scrollTopNow = document.body.scrollTop + document.documentElement.scrollTop;
					$menu.addClass(a);
					$headerNav.addClass(a);
					$headerNavInner.addClass(v);
					$headerNavSpMail.removeClass(v);
					$('.container').css({
						position: 'fixed',
						width: '100%',
						top: -1 * scrollTopNow,
						left: 0
					});
					$('body').addClass(f);
				}
				$(window).resize(function () {
					var windowWidth = $(window).width();
					if (windowWidth > 1024) {
						$menu.removeClass(a);
						$headerNav.removeClass(a);
						$headerNavInner.removeClass(v);
						$headerNavSpMail.addClass(v);
						$('.container').css({
							position: 'static'
						});
						$('body').removeClass(f);

						$(window).scrollTop(scrollTopNow);
					}
				});
			});
		},
		accordionParentElem: function accordionParentElem() {
			var $headerToggle = $('.js-accordionParentElem');

			$headerToggle.click(function () {
				if ($(this).hasClass(a)) {
					$(this).removeClass(a);
					$(this).parent().next('.js-accordionParentElemBlock').slideUp();
				} else {
					// $headerToggle.removeClass(a);
					// $headerToggle.parent().next('.js-accordionParentElemBlock').slideUp();
					$(this).addClass(a);
					$(this).parent().next('.js-accordionParentElemBlock').slideDown();
				}
			});
		},
		accordion: function accordion() {
			var $toggleBtn = $('.js-accordion');

			$toggleBtn.click(function () {
				if ($(this).hasClass(a)) {
					$(this).removeClass(a);
					$(this).next('.js-accordionBlock').slideUp();
				} else {
					// $toggleBtn.removeClass(a);
					// $toggleBtn.next('.js-accordionBlock').slideUp();
					$(this).addClass(a);
					$(this).next('.js-accordionBlock').slideDown();
				}
			});
		},
		fadeMegaMenu: function fadeMegaMenu() {
			var $btn = $('.js-header-accordion');
			var $btnClose = $('.js-header-nolayer');
			var $btnClose2 = $('.header-sub_nav');
			var setHeaderAccordion = function setHeaderAccordion() {
				var windowWidth = $(window).width();
				$btn.off('mouseenter');
				$btn.parent().off('mouseleave');
				$btnClose.off('mouseenter');
				$('.header').off('mouseleave');
				$btn.off('click');
				$('.header-mega').css('height', 'auto');
				if (windowWidth > 1024) {
					$btn.on('mouseenter', function () {
						var arrowPosition = 0;
						$btn.removeClass(a);
						$('.js-header-accordionBlock').stop().slideUp(400);
						if (window.innerWidth >= 1440) {
							arrowPosition = $(this).offset().left + $(this).innerWidth() / 2 - 80 + "px";
						} else {
							arrowPosition = $(this).offset().left + $(this).innerWidth() / 2 - 40 + "px";
						}
						$('.header-mega-inner-arrow').css('left', arrowPosition);
						$(this).addClass(a);
						$(this).next('.js-header-accordionBlock').stop().slideDown(400);
					});
					$btnClose.on('mouseenter', function () {
						$btn.removeClass(a);
						$btn.next('.js-header-accordionBlock').stop().slideUp(400);
					});
					$btnClose2.on('mouseenter', function () {
						$btn.removeClass(a);
						$btn.next('.js-header-accordionBlock').stop().slideUp(400);
					});
					$('.header').on('mouseleave', function () {
						$btn.removeClass(a);
						$btn.next('.js-header-accordionBlock').stop().slideUp(400);
					});
				} else {
					$btn.on('click', function () {
						if ($(this).hasClass(a)) {
							$(this).removeClass(a);
							$(this).next('.js-header-accordionBlock').slideUp();
						} else {
							$(this).addClass(a);
							$(this).next('.js-header-accordionBlock').slideDown();
						}
					});
				}
			};

			setHeaderAccordion();
			$(window).resize(function () {
				setHeaderAccordion();
			});
		},
		pcHoverSpToggle: function pcHoverSpToggle() {
			var agent = window.navigator.userAgent.toLowerCase();
			var ipad = agent.indexOf('ipad') > -1 || agent.indexOf('macintosh') > -1 && 'ontouchend' in document;
			if (!(ipad == true)) {
				// pc用
				if ($('.ua-desktop').length) {
					var $btn = $('.js-hoverToggle');
					$btn.on('mouseenter', function () {
						$(this).addClass(a);
						$(this).next('.js-hoverToggleBlock').stop().slideDown(400);
					});
					$btn.parent().on('mouseleave', function () {
						$btn.removeClass(a);
						$(this).children('.js-hoverToggleBlock').stop().slideUp(400);
					});
				}
			}
			// tablet sp用
			if ($('.ua-mobile').length) {
				var _$btn = $('.js-hoverToggle');
				_$btn.on('click', function () {
					if ($(this).hasClass(a)) {
						_$btn.removeClass(a);
						_$btn.next('.js-hoverToggleBlock').slideUp(400);
					} else {
						// $btn.removeClass(a);
						// $btn.next('.js-hoverToggleBlock').slideUp(400);
						$(this).addClass(a);
						$(this).next('.js-hoverToggleBlock').slideDown(400);
					}
				});
			}
		},
		openSearchBox: function openSearchBox() {
			var $btn = $('.js-search_open');
			var $btnClose = $('.js-close_bg');
			$btn.on('click', function () {
				$('.js-search_visible').css('display', 'block');
				$('.js-search_hide').css('display', 'none');
			});
			$btnClose.on('click', function () {
				$('.js-search_visible').css('display', 'none');
				$('.js-search_hide').css('display', 'flex');
			});
		},
		loadDelayScript: function loadDelayScript() {
			var _this = this;
			_this.headerScroll();
			_this.spMenu();
			_this.accordionParentElem();
			_this.accordion();
			_this.fadeMegaMenu();
			_this.pcHoverSpToggle();
			_this.openSearchBox();
		}
	};

	$(function () {
		return FUNCTIONS.localDecision() ? FUNCTIONS.localLoading() : FUNCTIONS.loadDelayScript();
	});
})(window.jQuery);